export const okButtonClass = 'popup-form_btn action-btn popup-btn-size ok-action';
export const cancelButtonClass = 'popup-form_btn action-btn popup-btn-size cancel-action light-blue-with-border';